export function formatCatalogMoney(amount, currency) {
  try {
    const formatter = new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: currency.toUpperCase(),
    })
    const digits = formatter.resolvedOptions().maximumFractionDigits

    return formatter.format(amount / 10 ** digits)
  } catch {
    return `${currency.toUpperCase()} ${amount}`
  }
}

export function formatCatalogInterval(price) {
  return price.intervalCount === 1
    ? `per ${price.interval}`
    : `every ${price.intervalCount} ${price.interval}s`
}
